import * as React from 'react';
import { Path, Svg } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" fill="none" {...props}>
        <Path d="M6 14L6 4" stroke={props.color ?? ds.colorValue.icon.primary} strokeWidth="1.5" />
        <Path
            d="M1 8L5.64645 3.35355C5.84171 3.15829 6.15829 3.15829 6.35355 3.35355L11 8"
            stroke={props.color ?? ds.colorValue.icon.primary}
            strokeWidth="1.5"
        />
    </Svg>
);
export default SvgComponent;
